import { ApiUserProfileDto } from 'kes-common';
import React, { Dispatch, SetStateAction } from 'react';

export default React.createContext<{
	refetchUser: (options?: any) => any;
	setUser: Dispatch<SetStateAction<ApiUserProfileDto>>;
	user: ApiUserProfileDto;
}>({ refetchUser: () => {}, setUser: () => {}, user: {} as ApiUserProfileDto });
